import { CollectionNoticeStatus, NotificationType } from '@core/models';
import { environment } from '@env/environment';

export const ADMINISTRATIVE_RULES_FREQUENCY = new Map([
  ['annual', '1 exhibición'],
  ['month', 'Mensual'],
  ['monthly', 'Mensual'],
  ['monthly11', 'Mensual (11 Meses)'],
  ['semester', '2 exhibiciones'],
]);

export const ALLOWED_BANKS_MSI = [
  'banco bilbao vizcaya argentaria s.a. (bbva)',
  'banco bilbao vizcaya argentaria, s.a.',
  'bbva',
  'bbva bancomer',
  'citibanamex',
  'banamex',
  'citi banamex',
  'bbva bancomer s.a.',
];

export const COLLECTION_NOTICE_CONCEPTS_IDS = {
  IN: 'ee73edaf-45d2-516a-adb3-b4efeb8b66fa',
  RI: '967a7d9c-0d62-5a39-a139-12fc95b43a52',
  EVENTS: '1f8cbde0-7a8f-5b59-8a8a-3b4b755e7132',
  LEASING: 'f043f958-631c-5731-bca5-4bb6a2c8e229',
  TUITION: '03aa4c6a-8701-5349-8bb3-2098f62ace49',
};

export const ALLOWED_CATEGORY_CONCEPTS_TO_APPLY_REFUND_REASON: AllowedConceptKey[] =
  [
    { IN: COLLECTION_NOTICE_CONCEPTS_IDS.IN },
    { RI: COLLECTION_NOTICE_CONCEPTS_IDS.RI },
  ];

export const ALLOWED_CATEGORY_CONCEPTS_TO_APPLY_REVERSE: AllowedConceptKey[] = [
  { IN: COLLECTION_NOTICE_CONCEPTS_IDS.IN },
  { RI: COLLECTION_NOTICE_CONCEPTS_IDS.RI },
];

export const ALLOWED_CONCEPTS_FISCAL_CREDITS: AllowedConceptKey[] = [
  { EVENTS: COLLECTION_NOTICE_CONCEPTS_IDS.EVENTS },
  { LEASING: COLLECTION_NOTICE_CONCEPTS_IDS.LEASING },
];

export const IN_RI_CONCEPTS: AllowedConceptKey[] = [
  { IN: COLLECTION_NOTICE_CONCEPTS_IDS.IN },
  { RI: COLLECTION_NOTICE_CONCEPTS_IDS.RI },
];

export const ALLOWED_CONCEPTS_MSI: AllowedConceptKey[] =
  environment.allowedConceptsMSI;

export const ALLOWED_CONCEPTS_MSI_SV: AllowedConceptKey[] = [
  { IN_QA: '56aa313c-362f-41ae-a907-93c231d2ac13' },
  { IN: 'ee73edaf-45d2-516a-adb3-b4efeb8b66fa' },
  { ANNUAL_1: '7adbe84e-f9e8-520e-9a33-7d6da2e122d5' },
  { ANNUAL_2: '358352b3-d32e-55e2-b339-ae0c182fe76b' },
];

export const DISALLOWED_TOTAL_REFUND_CONCEPTS: AllowedConceptKey[] = [
  { ANNUAL_1: '7adbe84e-f9e8-520e-9a33-7d6da2e122d5' },
  { ANNUAL_2: '358352b3-d32e-55e2-b339-ae0c182fe76b' },
];
export const DISALLOWED_TOTAL_REFUND_CONCEPTS_NAMES = [
  'colegiatura anual 2 exhibiciones',
  'colegiatura cnual 1 exhibición',
];

export const MAX_MSI: { [key: string]: number } = {
  sv: 12,
  mx: 6,
};

export const CASHIER_REJECTED_STATUS_CLASS: CollectionNoticeCashierSatatus = {
  0: 'default',
  1: 'default',
  2: 'danger',
  3: 'success',
  4: 'info',
};

export const CATEGORY_CONCEPTS_TO_APPLY_SPLIT: AllowedConceptKey[] = [
  { RI: COLLECTION_NOTICE_CONCEPTS_IDS.RI },
  { IN: COLLECTION_NOTICE_CONCEPTS_IDS.IN },
];

export const COLLECTION_CASHIER_REJECTED_STATUS: CollectionNoticeCashierSatatus =
  {
    0: 'Sin Rechazo',
    1: 'Sí',
    2: 'Pendiente',
    3: 'Completado',
    4: 'Resuelto',
  };

export const COLLECTION_CORE_SELECT_ITEMS = [
  { id: '73d3de91-79e1-5f58-818e-bfaaa68c5706', name: 'Colegiatura Mensual' },
  {
    id: '1b485fe3-d80f-55ca-8c14-c166fcd613a5',
    name: 'Colegiatura Mensual Bachillerato',
  },
  {
    id: '7adbe84e-f9e8-520e-9a33-7d6da2e122d5',
    name: 'Colegiatura Anual 1 exhibición',
  },
  {
    id: '358352b3-d32e-55e2-b339-ae0c182fe76b',
    name: 'Colegiatura Anual 2 exhibiciones',
  },
  { id: COLLECTION_NOTICE_CONCEPTS_IDS.IN, name: 'Inscripción' },
  { id: COLLECTION_NOTICE_CONCEPTS_IDS.RI, name: 'Reinscripción' },
];

export const COLLECTION_NOTICE_CASHIERS_STATUS = {
  DEFAULT: 0,
  REJECTED: 2,
  APPROVED: 3,
};

export const COLLECTION_NOTICE_DONATION_ITEMS = [
  {
    id: '56aa313c-362f-41ae-a907-93c231d2ac16',
    name: 'Donaci\u00f3n',
  },
  {
    id: '7685aa51-0110-53c9-8068-b22c6d29b25d',
    name: 'Donativo',
  },
  {
    id: '960db857-d906-5835-aec0-4a8dc3467d7c',
    name: 'Donativo para Proyecto Educativo',
  },
];

export const COLLECTION_NOTICE_STATUS_ALERT_TYPES: Map<string, string> =
  new Map([
    [CollectionNoticeStatus.BILLED, NotificationType.success],
    [CollectionNoticeStatus.CANCELLED, NotificationType.warning],
    [CollectionNoticeStatus.EXPIRED, NotificationType.process],
    [CollectionNoticeStatus.IN_PAYMENT_PROCESS, NotificationType.process],
    [CollectionNoticeStatus.INITIALIZING_PAYMENT, NotificationType.process],
    [CollectionNoticeStatus.PAID, NotificationType.success],
    [CollectionNoticeStatus.PAYMENT_VALIDATION, NotificationType.process],
    [CollectionNoticeStatus.PENDING, NotificationType.process],
    [CollectionNoticeStatus.PENDING_CHARGE_BACK, NotificationType.error],
    [CollectionNoticeStatus.PENDING_REFUND, NotificationType.warning],
    [CollectionNoticeStatus.PUBLIC_BILLED, NotificationType.success],
    [CollectionNoticeStatus.REFUND, NotificationType.warning],
    [CollectionNoticeStatus.REJECTED, NotificationType.error],
  ]);

export const CONCEPTS_WITH_INTEREST: string[] = [
  '1b485fe3-d32e-55e2-b339-ae0c182fe76b', // Colegiatura Anual 2 exhibiciones
  '1b485fe3-d80f-55ca-8c14-c166fcd613a5', // Colegiatura Mensual Bachillerato
  '73d3de91-79e1-5f58-818e-bfaaa68c5706', // Colegiatura Mensual
  '7adbe84e-f9e8-520e-9a33-7d6da2e122d5', // Colegiatura Anual 1 exhibición
];

export const PAYABLE_STATUS = [
  CollectionNoticeStatus.PENDING,
  CollectionNoticeStatus.EXPIRED,
];

export const BBVA_BANK = [
  'banco bilbao vizcaya argentaria s.a. (bbva)',
  'banco bilbao vizcaya argentaria, s.a.',
  'bbva',
  'bbva bancomer',
  'bbva bancomer s.a.',
];

export interface AllowedConceptKey {
  [name: string]: string;
}

export interface CollectionNoticeCashierSatatus {
  [name: number]: string;
}

export const COLLECTION_NOTICE_CORE_ITEMS = [
  'Colegiatura',
  'Reinscripción',
  'Inscripción',
];

// 72hrs
export const REFERENCE_GENERATION_DAYS_LIMIT = 3;
